module.exports = __webpack_public_path__ + "static/media/uxceomom-128.74ad5768.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pics/uxceomom-128.jpg
// module id = 1000
// module chunks = 0